import { CSSProperties } from 'react';

export const container: CSSProperties = {
  backgroundColor: '#8AE1FC',
  width: '100%',
};

export const body: CSSProperties = {
  margin: 'auto',
  position: 'relative',
  width: 360,
};

export const imageFull: CSSProperties = {
  width: '100%',
};

export const image1: CSSProperties = {
  bottom: 97,
  left: -54,
  position: 'absolute',
  width: 392,
};

export const aImage1: CSSProperties = {
  bottom: 520,
  position: 'absolute',
  right: 30,
  width: 102,
};
